import React from 'react';
import { Col, Row } from 'react-bootstrap';

import CaseMetricsGenericMetricChartContainer
  from '../Containers/CaseMetricsGenericMetricChartContainer';
import CaseMetricsHitCountChartContainer
  from '../Containers/CaseMetricsHitCountChartContainer';
import EngineMetricsDeltasContainer from '../Containers/EngineMetricsDeltasContainer';
import MetricsJobInfoContainer from '../Containers/MetricsJobInfoContainer';
import MetricsSelectorContainer from '../Containers/MetricsSelectorContainer';
import ViewScenarioStatusContainer from '../Containers/ViewScenarioStatusContainer';

import {
  colours as colorHelpers,
  pageTypes
} from './../helpers';

const EngineMetricsComponent = () => {
  return (
    <div>
      <Row>
        <Col sm={10} md={6} mdOffset={1}>
          <Row>
            <MetricsSelectorContainer pageType={pageTypes.ENGINEMETRICS} />
          </Row>
          <Row>
            <ViewScenarioStatusContainer />
          </Row>
        </Col>
        <Col md={5}>
          <MetricsJobInfoContainer pageType={pageTypes.ENGINEMETRICS} />
        </Col>
      </Row>
      <Row>
        <Col md={10} mdOffset={1}>
          <EngineMetricsDeltasContainer />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <h2> Source Counts </h2>
          <Col>
            <CaseMetricsGenericMetricChartContainer
              disablePointOptions
              getMetricFuncPerDataSet={[
                (m) => m && m.ncf.sourceCount ? m.ncf.sourceCount : 0
              ]}
              seriesColors={[colorHelpers.METRICS_CHARTS.NCF_DEFAULT]}
              seriesLabels={['NCF Source Count']}
            />
          </Col>
        </Col>
        <Col md={6}>
          <h2> Source Attribute Count </h2>
          <Col>
            <CaseMetricsGenericMetricChartContainer
              disablePointOptions
              getMetricFuncPerDataSet={[
                (m) => m && m.ncf.sourceAttributeCount ? m.ncf.sourceAttributeCount : 0
              ]}
              seriesColors={[colorHelpers.METRICS_CHARTS.NCF_DEFAULT]}
              seriesLabels={['NCF Source Attribute Count']}
            />
          </Col>
        </Col>
      </Row>
      <Row>
        <Col md={6} sm={12}>
          <h2> Case Size </h2>
          <Col>
            <CaseMetricsGenericMetricChartContainer
              getMetricFuncPerDataSet={[
                (m) => m && m.ccf.caseSize ? m.ccf.caseSize / 1e9 : 0,
                (m) => m && m.ncf.caseSize ? m.ncf.caseSize / 1e9 : 0
              ]}
              seriesColors={[
                colorHelpers.METRICS_CHARTS.CCF_DEFAULT,
                colorHelpers.METRICS_CHARTS.NCF_DEFAULT
              ]}
              seriesLabels={[
                'CCF Case Size',
                'NCF Case Size'
              ]}
            />
          </Col>
        </Col>
        <Col md={6}>
          <h2> Hit Count </h2>
          <CaseMetricsHitCountChartContainer />
        </Col>
      </Row>
    </div>
  );
};

export default EngineMetricsComponent;



// WEBPACK FOOTER //
// src/Components/EngineMetricsComponent.jsx